import { useAppDispatch } from 'app/hooks';
import { useTranslation } from 'react-i18next';
import { DocumentActionComponent } from 'sanity';
import { useRevalidatePageByDomainMutation } from 'services/template-app';
import { setErrorMessage, setSuccessMessage } from 'store/toast-slice';

export const RevalidateHomePage: DocumentActionComponent = (props) => {
    const dispatch = useAppDispatch();
    useTranslation('sanity');
    const [revalidatePageByDomain, { isSuccess: revalidateSuccess, isError: revalidateError }] =
        useRevalidatePageByDomainMutation();
    return {
        label: 'Revalidate Home Page',
        disabled: props.draft !== null,
        onHandle: async () => {
            if (props.published && props.published.domainName)
                await revalidatePageByDomain({ domainName: props.published.domainName as string, paths: ['/', '/en'] });

            // TODO: First time revalidation happens, message is not shown
            revalidateError && dispatch(setErrorMessage({ key: 'SANITY.HOME_PAGE_REVALIDATION_ERROR' })); // TODO: see how to implemnt this correctly
            revalidateSuccess && dispatch(setSuccessMessage({ key: 'SANITY.HOME_PAGE_REVALIDATION_SUCCESS' })); // TODO: see how to implemnt this correctly
        },
    };
};
